import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class ShipApplyLogService {
  private apiUrl = '/ships/shipapplylogs';
  private apiSpringUrl = '/spring/ships/shipapplylogs';

  constructor(private http: HttpService) { }

  get(params?: any): Promise<any> {
    let url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl;
    if (params != undefined) {
      url = `${url}?${params}`
    }
    return this.http.get(url);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/ship-apply-log/ship-apply-log.service.ts